<template>
    <div class="home" :style="{ background: homeImage.color ? `linear-gradient(180deg, ${homeImage.color}, ${adjustColor(homeImage.color)})` : 'linear-gradient(180deg, #003366, #336699)', ...charteVars }">
        <div class="background-layer"></div>
        <img class="centered-image" :src="homeResource" alt="">
        <div class="homeContent" :style="{ color: homeImage.color || '#ffffff' }">
            <div class="homeText" :style="textStyle">
                <h1 :style="{ backgroundColor: homeImage.color ? `${adjustBackgroundAlpha(homeImage.color)}` : 'rgb(38, 88, 139, 0.35)' }" v-html="processText(homeImage.text)"></h1>
            </div>
            <div class="home-arrow" :style="launchStyle" @click="exitHomePage">
                <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">

                <span v-html="processText(homeImage.launch_text)"></span>
                <q-icon name="navigate_next"></q-icon>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            console.log(props)
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                let name = props.homeImage.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                homeResource.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };

        /*async function blobToData(blob, name) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    let content = null;
                    let width = null;
                    let height = null;
                    const extension = name.split(".").pop().toLowerCase();
                    if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
                        const image = new Image();
                        image.src = reader.result;
                        image.onload = function () {
                            const aspectRatio = image.width / image.height;
                            width = Math.min(image.width, 200);
                            height = width / aspectRatio;
                            content = {
                                url: image.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        };
                    } else if (["mp4", "webm", "avi", "mov", "mkv"].includes(extension)) {
                        const video = document.createElement("video");
                        video.src = URL.createObjectURL(blob);
                        video.addEventListener('loadedmetadata', function () {
                            const aspectRatio = video.videoWidth / video.videoHeight;
                            width = Math.min(video.videoWidth, 300);
                            height = width / aspectRatio;

                            content = {
                                url: video.src,
                                width: width,
                                height: height
                            };
                            resolve(content);
                        })
                    } else if (["mp3", "wav", "ogg", "m4a"].includes(extension)) {
                        content = {
                            url: URL.createObjectURL(blob),
                            width: null,
                            height: null
                        };
                        resolve(content);
                    } else {
                        resolve(content);
                    }
                };
                reader.readAsDataURL(blob);
            });
        }*/

        const adjustColor = (color) => {
            // Adjust the color based on the input, this is a simple example, adjust as needed
            // Return a darker or lighter version of the color
            return color;
        };

        const adjustBackgroundAlpha = (color) => {
            // Convert the color to rgba with alpha of 0.35
            // Assuming color is in the format "#rrggbb"
            if (!color || color[0] !== '#' || color.length !== 7) return color;

            const r = parseInt(color.substr(1, 2), 16);
            const g = parseInt(color.substr(3, 2), 16);
            const b = parseInt(color.substr(5, 2), 16);
            return `rgba(${r}, ${g}, ${b}, 0.35)`;
        };

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data;
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }

        onMounted(start);

        return {
            homeResource,
            exhibitId,
            launchImage,
            launchResource,
            exitHomePage,
            adjustColor,
            adjustBackgroundAlpha,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>
<style scoped>
.home {
    position: relative;
    width: 100vw;
    height: 100vh;
    background: linear-gradient(180deg, #003366, #336699);
    overflow: hidden;
    perspective: 1000px;
}

.background-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: repeating-radial-gradient(circle, rgba(255,255,255,0.2), rgba(255,255,255,0.2) 1px, transparent 1px, transparent);
    background-size: 28px 28px;
    z-index: 1;
    mix-blend-mode: screen;
    animation: spin 60s linear infinite;
}

.centered-image {
    position: absolute;
    max-width: 60%;
    max-height: 60%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotateY(20deg);
    z-index: 2;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.4);
    object-fit: contain;
    transition: transform 0.3s;
}

.centered-image:hover {
    transform: translate(-50%, -50%) scale(1.1) rotateY(0deg);
}

.homeContent {
    position: absolute;
    bottom: 10%;
    left: 10%;
    z-index: 3;
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}

.homeText h1 {
    font-size: var(--expo-title-size, 32px);
    color: var(--expo-title-color, #ffffff);
    font-family: var(--expo-title-font, inherit);
    font-weight: var(--expo-title-weight, bold);
    background-color: rgb(38 88 139 / 35%);
    padding: 10px 25px;
    border-radius: 8px;
    backdrop-filter: blur(5px);
    white-space: pre-line;
}

.home-arrow {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 15px;
    font-size: 28px;
    color: #ffffff;
    cursor: pointer;
    animation-name: slideArrow;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-timing-function: ease-in-out;
}

.home-arrow span {
    white-space: pre-line;
}

.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}

@keyframes slideArrow {
    from {
        transform: translateY(-5px);
    }
    to {
        transform: translateY(5px);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>